import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "mark p-2" }, "プログラム", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "研究で使用したプログラムは公開する文化にしていくべきではないかと思っており、まずは個人レベルで試験的にそれをやってみることにしました(今後考え方が変わる可能性はあります)。リンクをクリックするとGitHubのリポジトリに飛ぶようになっています。私自身はそこまで数値計算に強い人間ではないので、(特に学生の頃に作ったコードは)あまり参考にならないかもしれないですが…", -1)
const _hoisted_3 = { class: "row p-2" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("dl", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programs, (program, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("dt", _hoisted_4, [
            _createElementVNode("a", {
              href: program.url,
              target: "_blank"
            }, _toDisplayString(program.title), 9, _hoisted_5),
            _createElementVNode("p", null, "(" + _toDisplayString(program.type) + ")", 1)
          ]),
          _createElementVNode("dd", {
            class: "col-md-8",
            innerHTML: program.text
          }, null, 8, _hoisted_6)
        ], 64))
      }), 128))
    ])
  ], 64))
}